import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the Capability EC (display = Name, value = USID) — used to grant a
// capability to a shared Position/User Group on an object's Visibility tab.
class CapabilityPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "Capability";
        this.static = false;
        this.enterpriseComponent = "Capability";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default CapabilityPicklistMetadata;
